<script>
export default {
    props: {
        land_lease: { type: Object, required: true }
    },
    computed: {
        durationText() {
            const v = this.land_lease.time_to_expiration;
            if (!v) return null;
            const p = [];
            if (v.years)
                p.push(v.years + " " + this.$tc("exp_module.years", v.years));
            if (v.months)
                p.push(
                    v.months + " " + this.$tc("exp_module.months", v.months)
                );
            if (v.days)
                p.push(v.days + " " + this.$tc("exp_module.days", v.days));
            return p.length ? p.join(", ") : null;
        }
    }
};
</script>

<template>
    <div>
        <h4>{{ $t("land_leases.contract_expiration") }}</h4>
        <div v-if="land_lease.expiration_date">
            <i class="far fa-calendar-alt"></i>
            {{ land_lease.expiration_date }}
            <div class="small text-muted" v-if="durationText">
                {{ $t("land_lease.expires_in") }} {{ durationText }}
            </div>
            <div class="small text-muted mt-3" v-if="land_lease.warning_days">
                {{
                    $t("land_leases.reminder_days_before_expiration", {
                        days: land_lease.warning_days
                    })
                }}
            </div>
        </div>
        <div v-else class="text-muted">
            {{ $t("land_leases.no_expiration_date") }}
        </div>
        <div v-if="land_lease.start_date" class="mt-4 text-muted">
            {{ $t("land_leases.start") }}: {{ land_lease.start_date }}
        </div>
    </div>
</template>
